import React from "react";
import { ScrollView } from "react-native";
import { colors } from "src/assets";

const htmlSting = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta http-equiv="X-UA-Compatible" content="IE=edge">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>Untitled Document</title>
<!-- Bootstrap -->
<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous">
</head>
<body>
<div  class="mx-2 mt-2">
<!-- body code goes here -->
<p>
チョク！利用規約<br/>
<br/>
チョクをご利用いただき、誠にありがとうございます。<br/>
以下の利用規約をご一読いただき、十分に理解の上でご利用いただきますようお願い申し上げます。特に前半部分ではご注意いただきたい重要な内容を、できるだけわかりやすくご案内しております。<br/>
<br/>
■お願い<br/>
チョクは、皆様に安全かつ安心して利用いただけるサービスを目指しております。そのために口コミ評価やブロック機能を活用し、良好な環境の維持に努めています。<br/>
しかしながら、インターネットサービスには一部の悪意を持つユーザーが存在することも事実です。当社でも努力はしておりますが完全な排除は困難なため、最終的にユーザー様ご自身の判断と責任においてご利用いただきますようお願いいたします。<br/>
<br/>
■ご利用に際して<br/>
チョクでは、ユーザー様同士が経験やスキルを通話で共有できるサービスを提供しております。<br/>
虚偽情報の記載は禁止しておりますが、ユーザー様が記載する情報に関して当社が全てを確認し、保証することはできかねます。情報の真偽はユーザー様の自己責任で判断いただきご利用ください。<br/>
怪しいと思われるユーザーに対しては、ブロック機能をお使いいただけます。被ブロック数が一定数を超えると、当該ユーザーは強制退会となります。<br/>
<br/>
■返金について<br/>
通話中に不具合や中断が発生する可能性がございます。これらはインターネット接続環境やご使用の機器、システム全般の問題が考えられます。大変恐縮ですが、これに起因する支払いの返金には応じかねます。通話品質に関しては各ユーザー様の利用環境に依存する部分も大きいため、ご理解賜りますようお願い申し上げます。<br/>
<br/>
■禁止事項<br/>
本サービスを通じて、他のユーザーへの個人情報（SNSアカウント等を含む）の提供や、各種勧誘行為は固く禁じられています。<br/>
<br/>
なお引き続き、以下の利用規約もよくお読みいただき、ご理解いただいた上でのご利用を心からお願い申し上げます。<br/>
<br/>
<br/>
この規約（以下「本利用規約」といいます。）は、株式会社チョク（以下「弊社」といいます。）が運営するWEB及びアプリケーションなどで提供するインターネットサービス「チョク！」において、弊社が提供する各種サービス（以下「本サービス」といいます。）の利用の諸条件を定めるものです。また、本規約は本サイトの利用に関して生ずるすべての関係に適用されるものとし、全てのユーザは本規約に承諾して利用するものとします。<br/>
<br/>
第 1 条 内容<br/>
1. 本サービスは、オンラインで通話を通じてユーザー間で情報等をやり取りするサービスです。ユーザー間の通話の場と機会を提供するもので、ユーザー間のいかなる通話内容や契約の保証等に関しては、すべて当事者であるユーザーの自己責任となります。弊社は、本規約中に別段の定めがある場合を除き、通話の取消しや内容保証などには一切関与しません。<br/>
２，本サービスの内容は、本利用規約及び別途ガイドがある場合はそれに規定する通りとします。<br/>
<br/>
<br/>
第 2 条 定義<br/>
1. 定義<br/>
本利用規約において、別途定義されている場合を除き、以下の意味を有するものとします。<br/>
(1)「サービス」とは、本サービスを介して販売者が提供するビデオ通話を含む通話サービスをいいます。<br/>
(2)「購入」とは、本サービスを介して販売者により提供されたサービスを通話時間に応じて、購入者が購入することをいいます。<br/>
(3)「販売」とは、本サービスを介して販売者によりサービスを販売することをいいます。<br/>
(4)「購入者」とは、本サービスを介して通話サービスを購入するユーザーをいいます。<br/>
(5)「販売者」とは、本サービスを介して通話サービスを販売するユーザーをいいます。<br/>
(6)「個人情報」とは、個人情報の保護に関する法律に定める「個人情報」を指すものとし、氏名など特定の個人を識別することができるものをいい、SNSのアカウントなどもこれに含みます。<br/>
(7)「コンテンツ」とは、弊社又はユーザーが本サービスに掲載・発信した全ての情報をいいます。<br/>
(8)「提供」とは、ユーザーが、本サービスにて、通話取引に必要なコンテンツを掲載・発信し、他のユーザーが閲覧可能かつ通話を取引できる状態にすることをいいます。<br/>
(9)「単価」とは、販売者が本サービスにおいて提供する際に設定するサービスの価格をいいます。表示は10分単位、または1分単位となりますが、売上の計算は1分単位で行われます。<br/>
(10)「ユーザー」とは、本サービスにアクセス及び閲覧及び利用する全ての個人及び法人及び団体を指します。<br/>
(11)「利用料」とは、本サービスの利用に関連して、弊社がユーザーから徴収する料金（販売手数料、決済手数料など）をいいます。<br/>
<br/>
<br/>
第 3 条 本規約の同意と変更<br/>
1. 本規約への同意<br/>
ユーザーは、本規約に同意をしたうえで、本規約の定めに従って本サービスを利用するものとします。<br/>
2. 本規約の変更<br/>
弊社は、必要に応じ、本規約の内容を随時変更できるものとします。本規約の変更後に、ユーザーが本サービスを利用した場合には、ユーザーは、本規約の変更に同意をしたものとします。弊社は、本規約の改定又は変更によりユーザーに生じたすべての損害について、弊社の故意又は重過失に起因する場合を除き、責任を一切負いません。<br/>
3. 未成年者の場合<br/>
未成年者のユーザーは、事前に保護者などに同意を得たうえで本サービスを利用してください。<br/>
<br/>
<br/>
第 4 条 ユーザー登録とアカウント情報<br/>
1. 登録<br/>
ユーザー登録は、ユーザー本人により正確な情報を入力してください。ユーザーは、登録内容に変更がある場合は、直ちに変更し、常にユーザー自身の正確且つ最新の情報が登録されている必要があります。<br/>
2. 複数登録の禁止<br/>
ユーザー登録は１ユーザー毎に１アカウントのみです。１ユーザーで複数のユーザー登録を行うことができないものとします。<br/>
3. 登録拒否<br/>
弊社は、以下各号のいずれかに該当する場合、ユーザー登録の申請を承認しません。または、承認後でも取り消す場合があります。<br/>
(1)本規約に定めるユーザー資格を満たしていない場合<br/>
(2)過去に本規約違反等により、弊社から利用停止等の処分を受けている場合<br/>
(3)過去を含め登録内容に正確ではない情報又は虚偽の情報があった場合<br/>
(4)本サービス及び他のユーザーの利用に支障をきたす場合やそのおそれがあると弊社が判断した場合<br/>
(5)過去5年以内に、暴力団等の反社会的勢力に所属または、これらのものとの関係を有することが判明した場合<br/>
(6)その他、弊社が不適当であると判断する場合<br/>
4. アカウント情報の管理<br/>
ユーザーは、入力したメールアドレス、パスワード等の情報（以下「アカウント情報」といいます。）を自ら管理する責任を負います。ユーザーは、アカウント情報を譲渡や貸与を含め第三者に一切利用させることはできません。<br/>
<br/>
<br/>
第 5 条 ユーザー登録の取消等<br/>
1. ユーザー登録の取消・利用停止等<br/>
弊社は、ユーザーが以下の各号のいずれかに弊社が該当したと判断した場合、事前の通知なく、ユーザー登録の取消、本サービスのアクセス拒否、利用停止等、又は、ユーザーに関連するコンテンツや情報の削除をすることができるものとし、弊社は、その理由を説明する義務を負わないものとします。なお、弊社は、ユーザーが以下の各号のいずれにも該当しないことを確認するまで本サービスへのアクセスの拒否、利用停止等の措置をとることができます。<br/>
(1)法令又は本規約に違反した場合<br/>
(2)不正行為があった場合<br/>
(3)過去を含め登録した情報が不正確または虚偽の情報であった場合<br/>
(4)登録した情報が既存の登録と重複している場合<br/>
(5)登録した携帯電話番号又はメールアドレスに連絡がとれない場合<br/>
(6)他のユーザーや第三者に迷惑をかけた場合<br/>
(7)ユーザーが登録した金融機関の口座に関し問題があることが判明した場合<br/>
(8)第 4 条第 3 項各号のいずれかに該当する場合<br/>
(9)ユーザーが自ら又は第三者をして、脅迫的または暴力的な言動や行為、不当な要求行為、風評の流布、信用を毀損させる行為、業務を妨害する行為をした場合<br/>
(10)評価や被ブロック数が弊社の定める数値を超えた場合<br/>
(11)その他弊社がユーザーに相応しくないと判断した場合<br/>
2. サービスの利用禁止等<br/>
弊社は、本条の措置を受けたユーザーに対し、将来にわたって弊社または弊社が関係する法人が提供するサービスの利用及びアクセスを禁止することができるものとします。<br/>
3. 弊社の免責<br/>
弊社は、本条の措置により生じる損害について、弊社の故意又は重過失に起因する場合を除き、責任を負わないものとします。<br/>
<br/>
<br/>
第 6 条 ユーザーの退会<br/>
1. 退会の手続<br/>
ユーザーは、所定の手続きにて弊社に退会を希望する旨を申し出ることができ、弊社の判断により認められた場合には退会することができます。但し、退会を希望した時点で、評価やポイントや売上など、本サービスに関してユーザーが保有している全ては放棄したものとします。<br/>
<br/>
<br/>
第 7 条 個人情報等の取扱い<br/>
1. プライバシーポリシー<br/>
弊社は、本規約のほか、プライバシーポリシーに従って個人情報等を取り扱います。<br/>
<br/>
<br/>
第 8 条 禁止事項<br/>
本サービスの全てのユーザーが、以下に定める行為及びそのおそれのある行為を行うことを禁止します。<br/>
・ユーザー自身のアカウント以外でアクセスすること<br/>
・本サービスで用意された以外の決済方法を促すこと<br/>
・本サービスの趣旨に沿わない行為<br/>
・販売者とは別の第三者のサービスを出品及び販売すること<br/>
・虚偽の情報または誤った情報または不正確な情報を記載及び投稿すること<br/>
・他ユーザーが撮影した画像、文章などを無断で使用すること<br/>
・外部サービスなどに誘導する行為<br/>
・迷惑行為<br/>
・勧誘活動を行うこと<br/>
・低俗、わいせつな記載及び投稿を行うこと<br/>
・マイページの基本情報以外にSNSアカウント等を含む個人情報を記載・投稿すること<br/>
・違法行為およびそのほう助にあたる行為<br/>
・差別を意識させたり、それらにつながる行為<br/>
・公序良俗に反する行為<br/>
・選挙運動に関するあらゆる行為<br/>
・第三者の著作権、商標権等の知的財産権を侵害する行為<br/>
・その他、弊社が不適切と判断する行為<br/>
<br/>
<br/>
第 9 条 サービスの提供<br/>
1. 提供手続等<br/>
販売者は、弊社所定の手続に従いサービスの提供を行うものとします。<br/>
2. プロフィール及びサービスの説明等<br/>
販売者は、サービスを提供する際に、ユーザーが正しくサービスを理解できるように、マイページにプロフィール情報や画像や説明を入力します。サービス提供ページには画像や説明を入力します。また、販売者は、自身や提供するサービスと関係のない画像や説明等を入力及び掲載してはいけません。<br/>
3. 法令遵守<br/>
販売者は、提供にあたっては、不当表示防止法、不正競争防止法、商標法、著作権法、景品表示法、その他の全ての法令を遵守しなければなりません。<br/>
4. 提供に関する本規約違反<br/>
提供に関して、弊社が本規約に違反する又は不適切であると判断した場合、その提供やその提供に対して発生していた購入行為等を弊社の判断で取消すことができるものとします。本項に基づく措置によってユーザーに生じる損害について、弊社の故意又は重過失に起因する場合を除き、弊社は責任を負わないものとします。<br/>
5. 弊社の免責<br/>
ユーザーの提供等によって、ユーザー及び第三者に生じる損害につき、弊社の故意又は重過失に起因する場合を除き、弊社は責任を負わないものとします。<br/>
<br/>
<br/>
第 10 条 サービスの購入<br/>
1. 購入手続<br/>
ユーザーは、弊社の定める手続により購入の意思をもって、購入の申込を行うものとします。<br/>
2. 弊社の免責<br/>
ユーザーの申込、購入等によって、ユーザー及び第三者に生じる損害につき、弊社の故意又は重過失に起因する場合を除き、弊社は責任を負わないものとします。<br/>
<br/>
<br/>
第 11 条 支払及び取引<br/>
1. 売買契約の成立<br/>
販売者が提供したサービスを購入者が申込、販売者が承諾し通話が開始して1分経過した時点で売買契約が成立するものとします。売買されるサービスは該当の通話が切れるまでとなります。販売者及び購入者は、売買契約に基づき発生した権利義務を第三者に譲渡、担保提供その他の処分することはできないものとします。<br/>
2. サービス等に関するトラブル<br/>
販売者及び購入者の間でサービス等に関してトラブルが発生した場合は、当該ユーザー間で解決するものとします。<br/>
3. キャンセル<br/>
本サービスの利用にあたり、販売者及び購入者のいずれも、サービス販売後及び購入後のキャンセル及び返金はいかなる理由でもできないものとします。<br/>
4. 支払手続<br/>
支払又は決済が本サービスに関して必要となる場合、本サービスのオンラインシステムを通じて行われるものとします。<br/>
5. 弊社の免責<br/>
ユーザーが本サービスに入力した決済手段又は金融機関の情報が第三者に利用されたこと等によってユーザーに生じた損害に関して、弊社の故意又は重過失に起因する場合を除き、弊社は責任を負わないものとします。<br/>
<br/>
<br/>
第 12 条 ユーザーの評価<br/>
1. 購入者による評価<br/>
購入者は、通話終了後、弊社所定の条件及び方式に従い販売者を評価するものとします。<br/>
2. 販売者による評価<br/>
販売者は、通話終了後、弊社所定の条件及び方式に従い購入者を評価するものとします。<br/>
3. 取引の完了<br/>
任意か否かに関わらずサービスの通話が切れた時点で、評価が購入者または販売者または両者からされていない場合でも、弊社は、当該取引が完了したものとみなすことができるものとします。<br/>
<br/>
<br/>
第 13 条 売買契約の取消<br/>
1. 売買契約が成立した場合においても、弊社は、弊社が本サービスの適切な運営のために必要と認める場合、当該売買契約を取り消すことができるものとします。<br/>
2. 前項により当該売買契約が取り消された場合には、販売者は、既に受領した売上を返還するなど、売買契約前の原状に復する一切の行為を認めるものとします。<br/>
<br/>
<br/>
第 14 条 販売手数料等及び振込申請<br/>
1. 販売手数料等<br/>
販売者は、弊社に対し、出品したサービスの売買契約が成立した場合、本サービスの販売手数料として、売買契約が成立したサービスの販売価格に20%＋消費税を乗じた金額を支払うものとします。<br/>
2. 売上の振込申請<br/>
取引完了後180日以内に、貯まった売上金は500円以上から弊社指定の方法にて振込申請が可能となります。その際、所定の各種手数料が発生します。<br/>
<br/>
<br/>
第 15 条 割引券<br/>
1. 割引券の取得と利用<br/>
ユーザーは、本サービスにおける各種キャンペーンへの参加など、弊社が指定する方法及び条件により、割引券を取得及び利用することができます。<br/>
2. 割引券が利用された場合の取扱い<br/>
割引券がサービス購入に利用された場合には、当該サービスの販売者は、販売価格から、利用された割引券に表示された金額又は割合を割引いた金額を、当該サービスの代金とすることに予め同意するものとします。場合により、弊社は、割引券による割引金額相当分を、当該サービスの販売手数料を上限に販売手数料から減額するものとします。<br/>
3. 割引券の交換等<br/>
ユーザーは、割引券を弊社が指定する本サービスにおけるサービス購入以外に利用することはできず、現金や経済的利益などと交換することはできません。また、弊社は、理由のいかんを問わず、割引券の払戻しは行いません。<br/>
4. 割引券の有効期限<br/>
ユーザーは、割引券を当初獲得した日から180日間又は、割引券付与時に別途弊社が定めた期間内にのみ利用することができますなお。有効期限を過ぎた未使用の割引券及び、ユーザーが退会または登録が取消しとなったユーザーが保有する割引券は全て消滅します。<br/>
<br/>
<br/>
第 16 条 本サービスの譲渡等<br/>
弊社は、本サービスの事業を第三者に譲渡した場合（事業譲渡、株式譲渡、会社分割その他本サービスの主体が移転する一切の場合を含みます。）、当該事業譲渡に伴い、本サービスの運営者たる地位、本利用規約上の地位、本利用規約に基づく権利及び義務並びに会員の登録情報及びその他情報を当該事業譲渡の譲受人に譲渡することができるものとし、本サービスの会員は、会員たる地位、本規約上の地位、本利用規約に基づく権利及び義務並びに会員の登録情報その他情報の譲渡につき予め承諾するものとします。<br/>
<br/>
<br/>
第 17 条 本サービスの中断・終了及び変更<br/>
1. 本サービスの中断<br/>
弊社は、以下の各号のいずれかに該当する場合には、ユーザーに事前に通知することなく本サービスの全部又は一部を中断する事ができるものとします。<br/>
(1)サーバー、通信回線、その他の設備の故障、障害の発生又はシステム及びプログラムの不具合その他の理由により本サービスの提供ができなくなった場合<br/>
(2)定期的又は緊急のシステム（サーバー、通信回線や電源、それらを収容する建築物などを含む）の保守、点検、修理、変更を行う場合<br/>
(3)火災、停電、漏水等により本サービスの提供ができなくなった場合<br/>
(4)地震、噴火、洪水、津波等の天災により本サービスの提供ができなくなった場合<br/>
(5)戦争、変乱、暴動、騒乱、労働争議等その他不可抗力により本サービスの提供ができなくなった場合<br/>
(6)法令又はこれに基づく措置により本サービスの提供ができなくなった場合<br/>
(7)その他運用上又は技術上、弊社が必要と判断した場合<br/>
2. 本サービスの終了及び変更<br/>
弊社は、弊社の任意により、本サービスの全部又は一部を終了及び変更ができるものとします。本サービスを終了する場合においては、弊社が適当と判断する方法で、事前にユーザーにその旨を通知するものとします。<br/>
<br/>
<br/>
第 18 条 知的財産権及びコンテンツ<br/>
1. 知的財産権等の帰属<br/>
本サービスを構成するすべての素材に関する権利は、弊社又は当該権利を有する第三者に帰属しています。ユーザーは、本サービスのすべての素材に関して、一切の権利を取得することはないものとし、権利者の許可なく、所有権、著作権を含む一切の知的財産権、肖像権、パブリシティー権等、コンテンツ素材に関する権利を侵害する一切の行為をしてはならないものとします。本規約に基づく本サービスの利用の許諾は、本サービスに関する弊社又は当該権利を有する第三者の権利の使用許諾を意味するものではありません。<br/>
2. 弊社による利用<br/>
ユーザー等により投稿された写真、動画、口コミ、情報等に関しては、本サービス及び弊社の指定する他サービスの宣伝、運営、研究開発及び発表等を目的として、弊社及び弊社の指定する者が自由に利用できるものとします。<br/>
3. コンテンツに関する責任<br/>
ユーザー等が本サービスに関連して発信又は掲載したコンテンツに関する一切の責任は、当該ユーザー等が負うものとし、弊社は、その内容、品質、正確性、信憑性、適法性、最新性、有用性等について、確認いたしません。また、弊社は、それらに関して保証しないものとします。<br/>
4. コンテンツの内容等<br/>
ユーザー等は、他のユーザー等が発信又は掲載するコンテンツについて、その内容、品質、正確性、信憑性、適法性、最新性、有用性等を、ユーザー等ご自身で判断する必要があります。弊社は、ユーザー等及び第三者が弊社のコンテンツを利用することにより生じる損害について、弊社の故意又は重過失に起因する場合を除き、責任を負わないものとします。<br/>
5. バックアップ<br/>
弊社はコンテンツのバックアップを行う義務を負わないものとします。ユーザーは、コンテンツのバックアップが必要な場合には、自己の費用と責任でこれを行うものとします。<br/>
6. コンテンツの変更及び削除<br/>
弊社は、ユーザーが本規約に違反又は本規約の精神に照らして不適切な行為を行ったと弊社が判断した場合、当該ユーザーが掲載したあらゆるコンテンツを、事前の通知なしに変更及び削除できるものとします。<br/>
<br/>
<br/>
第 19 条 ユーザーの準備と責任<br/>
1. 必要な機器<br/>
本サービスの提供を受けるために必要なコンピューター、スマートフォンその他の機器、ソフトウェア、通信回線その他の通信環境等は、ユーザーの費用と責任において準備及び維持するものとします。また、それらの準備や設置や操作方法等についても、ユーザーの費用と責任で行うものとし弊社は一切のサポートはしません。弊社は、本サービスがあらゆる機器等に適合することを保証するものではありません。これらの機器や通信環境やネットワークにより、サービスの提供が不安定又は中断された場合でも、弊社は一切の保証はしないものとします。<br/>
2. 成立のタイミング<br/>
ユーザーがインターネット回線を通じて行う本サービスへの入力、販売、購入、退会、その他の手続は、弊社のサーバーに当該手続に関するデータが送信され、弊社のシステムに当該手続の内容が反映された時点をもって成立するものとします。<br/>
3. トラブルの解決<br/>
本サービスに関連してユーザー間又はユーザーと第三者間で発生した、または今後発生する可能性のあるトラブルに関して、ユーザーは各自の費用及び責任で解決するものとします。トラブルが生じた際には、当事者間で解決するものとし、当該トラブルにより弊社が損害を被った場合は、当事者は連帯して当該損害を賠償するものとします。<br/>
4. 紛争の解決<br/>
ユーザーと第三者との間で、本サービスに関連して、裁判、クレーム、請求等のあらゆるトラブルを含む紛争が生じた場合、ユーザー各自の責任や費用で解決するものとし、弊社は、当該紛争に一切関与しません。当該紛争がユーザーの故意又は重過失に起因して生じた場合には、ユーザーは、当該紛争により弊社に生じた損害を連帯して賠償するものとします。<br/>
5. 費用の負担<br/>
弊社とユーザー間で紛争が生じた場合において、当該紛争がユーザーの故意又は過失に起因して生じた場合には、ユーザーは当該紛争に関連して弊社に発生した損害を賠償するものとします。<br/>
<br/>
<br/>
第 20 条 非保証と免責<br/>
1. 非保証<br/>
弊社は、本サービスの内容、品質、提供、本サービスに掲載されている画像やテキスト等情報の全て、本サービスの利用に伴う結果等、本サービスに関わる全てにおいて、正確性や有用性を含め一切保証しません。<br/>
2. 弊社の免責<br/>
本サービス提供における、不正確、不適切又は不明瞭な内容、表現、行為等により、ユーザー及び第三者に対して損害が生じた場合、弊社は、当該損害について責任を負わないものとします。<br/>
3. コンピュータウィルス等に関する非保証<br/>
弊社は、本サービスに関連するコンテンツの中に、コンピュータウィルス等有害なものが含まれていないことに関して保証するものではなく、これらにより生じた損害について、ユーザー及び第三者に対して、弊社の故意又は重過失に起因する場合を除き、責任を負わないものとします。<br/>
<br/>
<br/>
第 21 条 損害賠償<br/>
1. ユーザーの責任<br/>
ユーザーが本規約に違反した場合、当該ユーザーが、当該違反により損害を受けたユーザー及び第三者に対する損害賠償責任を含む、一切の責任を負うものとします。なお弊社が損害を被った場合は、当該ユーザーその他関連当事者は連帯して当該損害を賠償するものとします。<br/>
2. 弊社の免責<br/>
弊社は、弊社による本サービスの提供の停止、終了又は変更、ユーザー登録の取消、コンテンツ及びデータの削除又は消失､機器の故障その他本サービスに関連してユーザーが被った損害につき、弊社の故意又は重過失に起因する場合を除き、賠償する責任を負わないものとします。<br/>
3. 弊社の責任の範囲<br/>
弊社がユーザーに対して損害賠償責任を負う場合においても、弊社の責任は、弊社の債務不履行又は不法行為によりユーザーに生じた損害のうち現実に発生した直接かつ通常の損害に限るものとします。但し、賠償の上限は当該ユーザーが弊社に支払った利用料の過去5年分の合計を上限とします。<br/>
<br/>
<br/>
第 22 条 一般条項<br/>
1. ユーザーへの通知<br/>
弊社からユーザーへの通知又は連絡は、弊社が必要と判断した場合にのみ弊社が運営するウェブサイト又はアプリケーション内の適宜の場所への掲示により行なうものとします。弊社は、個々のユーザーに通知及び連絡をする必要があると判断した際、登録された電子メールアドレス、住所又は電話番号に対して通知及び連絡を行うことがあります。ユーザーが弊社に通知、連絡又は問い合わせをする必要が生じた場合、本サービスのお問い合わせフォームを利用するものとし、電話やFAXや来訪を行うことはできないものとします。弊社は、かかる連絡又は問い合わせがあった場合、弊社が定める方法により、ユーザーの本人確認を行うことができるものとします。また、問い合わせに対する回答方法に関しては、ユーザーではなく弊社が決めた回答方法を利用し、ユーザーはそれに承諾するものとします。なお問い合わせに対する弊社回答など、弊社が個別のユーザーに通知又は連絡した内容は、SNS等への投稿を含め第三者への開示、公表は一切認められません。<br/>
2. 譲渡禁止<br/>
ユーザーは、弊社の書面による事前の承諾なく、本規約に基づく契約上の地位又は本規約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、貸与、その他の処分をすることはできません。<br/>
3. 分離可能性<br/>
本規約のいずれかの条項又はその一部が、法令等により無効と判断された場合であっても、当該無効とされた以外の部分は、継続して有効に存続するものとします。<br/>
5. 定めのない事項等<br/>
本規約に定めのない事項又は本規約の解釈に疑義が生じた場合には、弊社及びユーザーは、信義誠実の原則に従って協議の上速やかに解決を図るものとします。<br/>
6. 言語<br/>
本規約は、日本語の正文のみが契約としての効力を有するものとします。<br/>
7. 準拠法及び裁判管轄<br/>
本規約は、日本法に基づき解釈されるものとし、ユーザーと弊社の間で生じた紛争については、その内容に応じて東京簡易裁判所又は東京地方裁判所を第一審の専属的合意管轄裁判所とします。<br/>
</p>
</div>

<script src="https://code.jquery.com/jquery-3.2.1.slim.min.js" integrity="sha384-KJ3o2DKtIkvYIK3UENzmM7KCkRr/rE9/Qpg6aAZGJwFDMVNA/GpGFF93hXpG5KkN" crossorigin="anonymous"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js" integrity="sha384-ApNbgh9B+Y1QKtv3Rn7W3mgPxhU9K/ScQsAP7hUibX39j7fakFPskvXusvfa0b4Q" crossorigin="anonymous"></script>
<script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js" integrity="sha384-JZR6Spejh4U02d8jOt6vLEHfe/JQGiRRSQQxSfFWpi1MquVdAyjUar5+76PVCmYl" crossorigin="anonymous"></script>
</body>
</html>`;

export type TermsScreenNavigationParam = undefined;

export const TermsScreen: React.FC = () => {
  return (
    <ScrollView
      style={{
        flex: 1,
        backgroundColor: colors.white,
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: htmlSting }} />
    </ScrollView>
  );
};
